import type { WorkflowsState } from '.';
import type {
  WidgetComponent,
  ContextVariables,
  SelectIntentComponent,
  ButtonComponent,
  UserMessageComponent,
  WorkflowConfigArgs,
  FilteredWorkflowConfig,
} from '../../api/types';
import { isFormComponent } from '../../api/types';

// pre-populate context variables with field.pre_populated_value;

export const getPrepopulatedComponents = (
  widgetComponents: WidgetComponent[],
) => {
  return widgetComponents?.map(comp => {
    const compCopy = Object.assign({}, comp);
    if (isFormComponent(comp)) {
      const contextVariables: ContextVariables = {};
      comp?.component_fields?.form_fields.map(field => {
        const pre = field.pre_populated_value;
        if (pre) contextVariables[field.output_variable] = pre;
      });
      compCopy.contextVariables = contextVariables;
    }

    return compCopy;
  });
};

export const getSelectIntentStep = (
  greetingMesage?: string,
  isSent = false,
  query = '',
) => {
  const selectIntentStep: SelectIntentComponent = {
    component_fields: {
      custom_greeting: greetingMesage,
      show_greeting_message: true,
      show_top_n_intents: true,
    },
    component_type: 'restart_conversation',
    isSent,
    query,
  };
  return selectIntentStep;
};

export const getWorkflowTagSelectorStep = (
  workflowTags: Array<string>,
  prompt: string,
) => {
  const tagSelector: ButtonComponent = {
    component_fields: {
      multi_select: false,

      options: workflowTags.map(tag => {
        return { display_name: tag, value: tag };
      }),
      output_variable: 'tag_selector',
      prompt,
      should_confirm_tag: true,
    },

    component_type: 'buttons',
  };

  return tagSelector;
};

export const getWorkflowTagSelectorMessageStep = (greetingLine: string) => {
  const messageStep: UserMessageComponent = {
    component_fields: {
      message: greetingLine,
    },
    component_type: 'text_message',
  };

  return messageStep;
};

export const isValidConversationStatusForCsat = (
  status?: WorkflowsState['conversationStatus'],
) => {
  if (!status) {
    return false;
  }

  return status === 'success';
};

export function filterWorkflowConfig(
  config: WorkflowConfigArgs | null,
): FilteredWorkflowConfig | null {
  // filter conversation_id out of config
  if (!config) {
    return null;
  }

  // eslint-disable-next-line unused-imports/no-unused-vars
  const { conversation_id, ...filteredConfig } = config;

  return filteredConfig;
}
